import { render, staticRenderFns } from "./searchBooks.vue?vue&type=template&id=a8cfcbca&scoped=true&"
import script from "./searchBooks.vue?vue&type=script&lang=js&"
export * from "./searchBooks.vue?vue&type=script&lang=js&"
import style0 from "./searchBooks.vue?vue&type=style&index=0&id=a8cfcbca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cfcbca",
  null
  
)

export default component.exports